// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"484":"6955ea5b","576":"26f8d618","787":"8fbb758a"}[chunkId] + ".chunk.js";
};